module.exports = __webpack_public_path__ + "static/media/logo_large_withtext.3b1a2570.png";